import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class BalanceReport extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			loading: true
		}
	}
	componentDidMount() {
		this.httpPost("api/v1/report/balance")
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.setState({
						data: data,
						loading: false
					})
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderForm() {
		return <div className="container">
			<div className="center-block">
				<div className="row" style={{ "margin-bottom": "20px", "margin-top": "15px" }}>
					<h4 className="txt-gray text-center txt-bold">ترازنامه</h4>
					<h5 className="text-muted text-center"></h5>
					<h5 className="text-muted text-center">{this.state.data.today}</h5>
				</div>
				<div className="mr-t-5 text-left">
					<button className="btn btn-no-frame btn-smoke" onClick="printBalance()">
						<span className="fa fa-print"></span>
					</button>
					<button className="btn btn-no-frame btn-smoke" onClick="pdfBalance()">
						<span className="fa fa-file-pdf-o"></span>
					</button>
					<button className="btn btn-no-frame btn-smoke" onClick="renderExcel('balance','','')">
						<span className="fa fa-file-excel-o"></span>
					</button>
				</div>
				<div className="row" style={{ "border-top": "2px solid whitesmoke" }} >
					<div className="col-sm-6">
						<div className="bs-callout bs-callout-success" style={{ "background-color": "#EDF8ED" }} >
							<div>
								<div className="row">
									<div className="col-xs-6">
										<h4>دارایی ها</h4>
									</div>
									<div className="col-xs-3">ابتدای دوره</div>
									<div className="col-xs-3">انتهای دوره</div>
								</div>
							</div>
							{this.state.data.darayi.map(d =>[
								<div>
									<div className="row txt-bold" style={{ "border-top": "1px solid #abdeab","border-bottom": "1px solid #abdeab"}} >
										<div className="col-xs-12">{d.accountName}</div>
									</div>
								</div>
								,
								d.items.map(i=> <div>
									<div className="row">
										<div className="col-xs-6">{i.accountName}</div>
										<div className="col-xs-3">{this.money(i.start)}</div>
										<div className="col-xs-3">{this.money(i.finish)}</div>
									</div>
								</div>)
							])}
							<div>
								<div className="row bg-success txt-bold" style={{ "margin-top": "10px", "margin-bottom": "-15px" }}>
									<div className="col-xs-6">
										<h4>جمع دارایی ها</h4>
									</div>
									<div className={"col-xs-3 " + (this.state.data.sumDarayiFirst < 0 ? "red" : "")}>{this.money(this.state.data.sumDarayiFirst)}</div>
									<div className={"col-xs-3 " + (this.state.data.sumDarayi < 0 ? "red" : "")}>{this.money(this.state.data.sumDarayi)}</div>
								</div>
							</div>

						</div>
					</div>
					<div className="col-sm-6" style={{ "border-right": "2px solid whitesmoke" }} >
						<div className="bs-callout bs-callout-danger" style={{ "background-color": "#FFF1F2" }} >
							<div>
								<div className="row">
									<div className="col-xs-6">
										<h4>بدهی ها</h4>
									</div>
									<div className="col-xs-3">ابتدای دوره</div>
									<div className="col-xs-3">انتهای دوره</div>
								</div>
							</div>
							{this.state.data.bedehi.map(d => [
								<div>
									<div className="row txt-bold" style={{ "border-top": "1px solid #abdeab", "border-bottom": "1px solid #abdeab" }} >
										<div className="col-xs-12">{d.accountName}</div>
									</div>
								</div>
								,
								d.items.map(i => <div>
									<div className="row">
										<div className="col-xs-6">{i.accountName}</div>
										<div className="col-xs-3">{this.money(i.start)}</div>
										<div className="col-xs-3">{this.money(i.finish)}</div>
									</div>
								</div>)
							])}
							<div className="row bg-danger txt-bold" style={{ "margin-top": "10px", "margin-bottom": "-15px" }} >
								<div className="col-xs-6">مجموع بدهی ها</div>
								<div className={"col-xs-3 " + (this.state.data.sumFirstBed < 0 ? "red" : "")}>{this.money(this.state.data.sumFirstBed)}</div>
								<div className={"col-xs-3 " + (this.state.data.sumBed < 0 ? "red" : "")}>{this.money(this.state.data.sumBed)}</div>
							</div>
						</div>
						<div className="bs-callout bs-callout-info" style={{ "background-color": "#F4FDFF" }} >
							<h4>حقوق صاحبان سهام</h4>
							{this.state.data.sarmaye.map(d => [
								<div>
									<div className="row txt-bold" style={{ "border-top": "1px solid #abdeab", "border-bottom": "1px solid #abdeab" }} >
										<div className="col-xs-12">{d.accountName}</div>
									</div>
								</div>
								,
								d.items.map(i => <div>
									<div className="row">
										<div className="col-xs-6">{i.accountName}</div>
										<div className="col-xs-3">{this.money(i.start)}</div>
										<div className="col-xs-3">{this.money(i.finish)}</div>
									</div>
								</div>)
							])}
							<div className="row bg-info txt-bold" style={{ "margin-top": "10px", "margin-bottom": "-15px" }} >
								<div className="col-xs-6">حقوق صاحبان سهام</div>
								<div className={"col-xs-3 " + (this.state.data.sumSahamFirst < 0 ? "red" : "")}>{this.money(this.state.data.sumSahamFirst)}</div>
								<div className={"col-xs-3 " + (this.state.data.sumSaham < 0 ? "red" : "")}>{this.money(this.state.data.sumSaham)}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row txt-bold" style={{ "margin": "1px", "margin-bottom": "15px", "margin-top": "0px", "background-color": "rgb(95, 95, 95)", "color": "whitesmoke" }} >
					<div className="col-xs-6">
						<span className="pull-right">جمع دارایی ها</span>
						<span className="pull-left">{this.money(this.state.data.sumDarayi)} {this.state.data.global.company.CurrencyUnit}</span>
					</div>
					<div className="col-xs-6">
						<span className="pull-right">جمع بدهی ها و سرمایه</span>
						<span className="pull-left">{this.money(this.state.data.sumSaham + this.state.data.sumBed)} {this.state.data.global.company.CurrencyUnit}</span>
					</div>
				</div>
			</div>

			<div style={{ "margin-top": "50px" }} ></div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
				this.renderForm(),
				<Footer />
			];

		return contents;
	}
}